import AuthContainer from '@webclient/components/AuthContainer';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const SITE_KEY = String(import.meta.env.VITE_RECAPTCHA_KEY);

export default function ReCaptchaProvider({
  children,
}: React.PropsWithChildren): JSX.Element {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
      <AuthContainer>{children}</AuthContainer>
    </GoogleReCaptchaProvider>
  );
}
